import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import cone from "common/assets/images/cone.png";
import { Render3dStore } from "modules/render3D/Render3dStore";
import {
  Paper,
  withStyles,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  Button,
} from "@material-ui/core";
import cube from "common/assets/images/ViewerProperty.png";
import { WBSStore } from "modules/WBS/WBSStore";
import WBSProperties from "./WBSProperties";
import multipleElements from "common/assets/images/multipleElements.png";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { Map, RemoveCircle, Close } from "@material-ui/icons";
import { CompareBlack, Copy } from "common/icons";
import classNames from "classnames";
import PropertiesTable from "modules/customProperties/components/PropertiesTable";
import CustomProps from "modules/customProperties/components/CustomProperties";
import RowCode from "./RowCode";
import { DisplayButton } from "./RowProperties/Components";
import CostOriginProperties from "./RowProperties/CostOriginProperties";
import { TakeOffService } from "modules/takeOff/TakeOffService";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { CustomPropertyStore } from "modules/customProperties/CustomPropertyStore";
import { WBSItemOccurrencesStore } from "modules/WBS/WBSItemOccurrencesStore";
import { EContentType, ERowType, EWBSView } from "common/enums";
import { ModelMap } from "modules/modelMap/models/ModelMap";

const styles = (theme) => ({
  title: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    backgroundColor: "#2E2D2F",
    color: "#ABC200",
    padding: "10px 18px",
    textTransform: "uppercase" as any,
    letterSpacing: "1px",
  },
  table: {
    display: "table",
    height: "calc((100vh - 68px) * 0.85)",
  },
  tableCell: {
    display: "table-cell",
    verticalAlign: "middle",
    padding: "0 25px",
    textAlign: "center" as any,
  },
  stageTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "rgba(255,255,255,0.87)",
  },
  stageSubtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 300,
    color: "rgba(255,255,255,0.67)",
  },
  content: {
    padding: "15px",
    overflowY: "scroll" as any,
    height: "400px",
  },
  formControl: {
    width: "100%",
    marginBottom: "25px",
  },
  origin: {
    paddingTop: "15px",
    fontFamily: "Roboto",
    fontSize: "13px",
    fontWeight: 400,
    color: "#e2e2e3",
  },
  container: {
    backgroundColor: "#2a292f",
    overflow: "hidden",
    height: "calc(100vh - 33px)",
    display: "flex",
    flexDirection: "column" as any,
    minWidth: "250px",
    background: "linear-gradient(to bottom, #2A292F 85%, #000)",
  },
  topBar: {
    backgroundColor: "#3A393E",
    height: "40px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    color: "#dedede",
  },
  topBarText: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    color: "#ABC200",
    letterSpacing: "1px",
    paddingLeft: "6px",
    alignItems: "left",
  },
  topBarWrapper: {
    width: "100%",
    display: "flex",
    paddingBottom: "10px",
    alignItems: "center",
  },
  texttitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    color: "#dedede",
  },
  text: {
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "rgba(255, 255, 255, 0.87)",
    padding: "5px",
    marginBottom: "0",
    marginTop: "2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap" as any,
    marginLeft: "10px",
    fontWeight: "500" as any,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  imgIcon: {
    marginLeft: "15px",
  },
  tooltip: {
    width: "120px",
  },
  uploadText: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#A8A8A8",
    padding: "5px",
    letterSpacing: "0.5px",
    marginTop: "4px",
    fontWeight: "600" as any,
  },
  icon: {
    color: "#A8A8A8",
    size: "11px",
    padding: "3px",
    alignItems: "middle",
  },
  iconNew: {
    margin: 0,
    width: "30px",
    height: "30px",
    padding: "3px",
    alignItems: "middle",
  },
  provisorio: {
    background: "#363637",
    paddingLeft: "0",
    borderBottom: "1px solid black",
  },
  iconWrap: {
    padding: "0 2px",
  },
  iconUploadText: {
    border: "1px solid #1D1D1D",
    background: "#272727",
    padding: "0",
    textTransform: "uppercase" as any,
    borderRadius: "4px",
    transition: "all 0.3s",
    "&:hover": {
      background: "#353539",
    },
  },
  listicon: {
    color: "#dedede",
    size: "8px",
    padding: "0px",
    alignItems: "left",
  },
  warning: {
    backgroundColor: "#ffa000",
  },
  progress: {
    margin: 0,
    color: "#ABC200",
  },

  tableTwo: {
    display: "table",
    height: "calc(100vh - 40px)",
    paddingTop: "100px",
  },
  list: {
    margin: "0px",
    overflow: "auto",
  },
  listNew: {
    margin: "0px",
    overflow: "auto",
    padding: 0,
    marginTop: "62px",
  },
  ul: {
    padding: 0,
    display: "inline",
  },
  colorSwitchBase: {
    color: "#dedede",
    "&$colorChecked": {
      color: "#ABC200",
      "& + $colorBar": {
        backgroundColor: "#ABC200",
      },
    },
  },
  colorBar: {},
  colorChecked: {
    color: "#ABC200",
  },
  switchIcon: {},
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    height: "30px",
    margin: "5px 0",
    paddingTop: "5px",
    width: "100%",
  },
  tablePropsWrapper: {
    marginTop: "3px",
  },
  tablePropsTitle: {
    fontFamily: "Raleway",
    padding: "8.5px",
    color: "#919191",
    fontWeight: "700" as any,
    letterSpacing: "1px" as any,
    fontSize: "9px",
  },
  tableProps: {
    width: "100%",
    background: "#363637",
    borderCollapse: "collapse" as any,
    border: "1px solid #2A292F",
  },
  displayForm: { display: "block", marginBottom: 25 },
  button: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#A8A8A8",
    padding: "5px",
    letterSpacing: "1px",
    fontWeight: "400" as any,
    border: "1px solid #1D1D1D",
    background: "#272727",
    "&:hover": {
      background: "#353539",
    },
    borderRadius: "4px",
  },
  confirmButton: {
    cursor: "pointer",
    padding: "8px 8px",
    color: "#ABC200",
  },
  closeIcon: {
    right: "20px",
    top: "14px",
  },
});

type IProps = {
  classes: any;
};

@observer
class Tab1 extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }
  state = {
    rowCode: { value: undefined, index: -1, line: undefined as any },
    categories: [1, 2, 3, 4, 5],
    decimalPlaces: 1,
    roundingRule: "",
    formula: "=",
    index: -1,
    updateQtt: false,
    open: false,
    snackOpen: false,
  };

  handleClickOpenRemoveDialog = () => {
    this.setState({ open: true });
  };

  handleClickClose = () => {
    this.setState({ open: false });
  };

  handleCodeFocus = (e) => {
    this.state.rowCode = {
      value: e.target.value,
      index: WBSStore.selectedLine.index,
      line: WBSStore.selectedLine,
    };
  };

  handleCodeBlur = async (e) => {
    const newCode = e.target.value.trim();
    const { value, line, index } = this.state.rowCode;

    if (!line) return;
    if (value === newCode) return;

    if (line.data.parentTask) {
      await WBSStore.handleWBSTableChangeTask(
        line,
        index,
        "content",
        "rowCode",
        newCode
      );
      WBSStore.changeAllArray({ rowCode: newCode }, line);
    } else {
      await WBSStore.handleWBSTableChange(
        line,
        index,
        "content",
        "rowCode",
        newCode
      );
    }

    if (!WBSStore.updateResource) {
      WBSStore.updateResource = true;
    }
  };

  handleChange = (event) => {
    const contentType = WBSStore.selectedLine.data.contentType;
    const value = event.target.value;
    // WBSStore.changeSelectedLineCategory(event.target.value);
    WBSStore.changeSelectedLineCategory(value);
    ToolbarStore.handelActions({
      originalOperation: "changeSelectedLineCategory",
      undoOperation: "changeSelectedLineCategory",
      data: {
        undoFunction: {
          function: "changeSelectedLineCategory",
          params: [contentType],
          selectedLine: [],
        },
        originalFunction: {
          function: "changeSelectedLineCategory",
          params: [value],
        },
      },
    });

    if (!WBSStore.updateResource) {
      WBSStore.updateResource = true;
    }
  };

  typeOfLine = (line) => {
    if (line.data.rowType === ERowType.RESOURCE) {
      if (EContentType.LABOR == line.data.contentType)
        return EContentType.LABOR;
      else if (EContentType.MATERIAL == line.data.contentType)
        return EContentType.MATERIAL;
      else if (EContentType.EQUIPMENT == line.data.contentType)
        return EContentType.EQUIPMENT;
      else if (EContentType.TASK == line.data.contentType)
        return EContentType.TASK;
      else if (EContentType.OTHER == line.data.contentType)
        return EContentType.OTHER;
      else return EContentType.OTHER;
    } else if (line.data.rowType === ERowType.BLANK) {
      return EContentType.OTHER;
    } else {
      return EContentType.TASK;
    }
  };

  getNameItem(count): any {
    if (count > 1) {
      return count + i18n.viewer.properties.multipleSelection;
    } else {
      return count + i18n.viewer.properties.singleSelection;
    }
  }

  renderModelMapName = () => {
    const { selectedLine } = WBSStore;
    let modelMaps =
      selectedLine.index !== -1 && selectedLine.data
        ? ModelMapStore.modelMaps.filter((mm) => {
            return mm.id === selectedLine.data.fromModelMap;
          })
        : [];

    if (modelMaps.length <= 0) {
      return i18n.project.rightSideMenu.takeOffPath;
    }

    let modelMapName = modelMaps[0].data.name;

    return modelMapName;
  };

  renderPath = () => {
    const joinString = " ‏‏‎  ‏‏‎  ‏‏‎ > ‏‏‎  ‏‏‎  ‏‏‎ ";
    const { selectedLine } = WBSStore;
    let modelMapName =
      selectedLine.index !== -1 && selectedLine.data
        ? ModelMapStore.modelMaps.filter((mm) => {
            return mm.id === selectedLine.data.fromModelMap;
          })
        : [];

    if (modelMapName.length <= 0) {
      return i18n.project.rightSideMenu.takeOffPath;
    }

    let hasPath = this.hasTakeOffPath();
    let modelMapInnerPath =
      selectedLine.index !== -1 && hasPath && selectedLine.data.takeOffQuantity
        ? selectedLine.data.takeOffQuantity.slice(1).reverse().join(joinString)
        : "";
    return modelMapInnerPath;
  };

  hasTakeOffPath = () => {
    const { selectedLine } = WBSStore;
    let hasPath =
      selectedLine &&
      selectedLine.data.takeOffQuantity &&
      selectedLine.data.takeOffQuantity.length >= 1;
    return hasPath;
  };

  handleClick = async (event) => {
    const modelMapId = WBSStore.selectedLine.data.fromModelMap;
    const modelMapQuantity = WBSStore.selectedLine.data.takeOffQuantity[0];
    let tkoList = await TakeOffService.getordernedList(modelMapId);
    let tkoItem = tkoList.filter((el) => el.description === modelMapQuantity);
    this.setState({ open: false });
    TakeOffStore.removeQuantityLinkWithTakeOffItem();
    await ToolbarStore.handelActions({
      originalOperation: "removeQuantityLinkWithTakeOffItem",
      undoOperation: "addQuantityFromTakeOffItem",
      data: {
        undoFunction: {
          function: "addQuantityFromTakeOffItem",
          params: [tkoItem[0]],
          selectedLine: [],
        },
        originalFunction: {
          function: "removeQuantityLinkWithTakeOffItem",
          params: [],
        },
      },
    });
    this.checkRemoveQuantityLinkFromTakeOff();
  };

  checkRemoveQuantityLinkFromTakeOff = (checkCount: number = 0) => {
    let hasPath = this.hasTakeOffPath();
    if (hasPath && checkCount < 30) {
      setTimeout(
        () => this.checkRemoveQuantityLinkFromTakeOff(checkCount++),
        500
      );
    } else {
      this.setState({ updateQtt: !this.state.updateQtt });
    }
  };

  // Monta o array de componentes para serem isolados no visualizador 3D pelo take off
  mountIsolateArrayByTakeOff = async (modelMapId, isolateArray) => {
    let tk = await TakeOffService.getTakeOffDataAll(modelMapId);

    let data: any = tk.data ? tk.data : [];
    let firstItem = data ? data[0] : undefined;
    if (firstItem) {
      let guidArray: any = [];

      for (let i = 0; i < data.length; i++) {
        for (var key in data[i].GUID) {
          guidArray.push(...data[i].GUID[key]);
        }
      }

      isolateArray.push({
        modelId: Object.keys(firstItem.GUID)[0],
        GUID: [...guidArray],
      });

      return isolateArray;
    }
  };

  // Monta o array de componentes para serem isolados no visualizador 3D
  mountIsolateArray = (model: ModelMap, isolateArray) => {
    const filesKey = model ? Object.keys(model.GUID) : [];

    for (const key of filesKey) {
      let listItems = model.GUID[key];
      if (listItems && listItems.length) {
        isolateArray.push({
          modelId: key,
          GUID: [...listItems],
        });
      }
    }

    return isolateArray;
  };

  handleIsolateClick = async (e) => {
    Render3dStore.resetViewer();
    let isolateArray: any = new Array();
    let modelMapId = WBSStore.selectedLine.data.fromModelMap; // id do ModelMap vinculado a linha
    let rowType = WBSStore.selectedLine.data.rowType; // tipo da linha
    let modelMapDescription = WBSStore.selectedLine.data.modelMapDescription; // Descrição desse insumo que está no ModelMap
    let modelMapFull = WBSStore.selectedLine.data.modelMapFull; // Se esta linha está dentro de uma etapa de ModelMap
    let modelMapTakeOffQuantity = WBSStore.selectedLine.data.takeOffQuantity; // Se o quantitativo da linha está vinculado a um ModelMap

    if (rowType !== ERowType.STAGE) {
      // Se a linha selecionada não for uma linha de ETAPA
      let tk;
      // Pega os dados do TakeOff
      if (modelMapTakeOffQuantity) {
        //se tiver modelMapTakeOffQuantity
        tk = await TakeOffService.getTakeOffData(
          modelMapId,
          modelMapTakeOffQuantity[0]
        );
      } else {
        tk = await TakeOffService.getTakeOffData(
          modelMapId,
          modelMapDescription
        );
      }

      if (tk.error.error === false) {
        // casonão tenha erros no TakeOff
        if (tk.data) {
          isolateArray = this.mountIsolateArray(tk.data, isolateArray);
        }

        Render3dStore.setIsolateArray(isolateArray);
        WBSStore.openViewer3D();
        Render3dStore.setItemsToIsolate();
      } else {
        // Caso o TakeOff venha com erros
        console.log(tk.error.message);
      }
    }
    // Caso a linha selecionada seja uma ETAPA e faça parte de um ModelMap
    if (modelMapFull === true && rowType === ERowType.STAGE) {
      let model = await ModelMapStore.getModelMap(modelMapId);

      if (model) {
        isolateArray = this.mountIsolateArray(model.data, isolateArray);
      }

      if (!isolateArray || !isolateArray.length) {
        isolateArray = await this.mountIsolateArrayByTakeOff(
          modelMapId,
          isolateArray
        );
      }

      Render3dStore.setIsolateArray(isolateArray);
      WBSStore.openViewer3D();
      Render3dStore.setItemsToIsolate();
    }
  };

  render() {
    const { categories } = this.state,
      { selectedLine, selectedLineIndexResources } = WBSStore;
    const { classes } = this.props;
    let count = Render3dStore.countModelElements();
    const libraries = Render3dStore.libraries,
      name = this.getNameItem(count);
    let takeOffDesc =
      selectedLine.index !== -1 &&
      selectedLine.data &&
      selectedLine.data.takeOffQuantity &&
      selectedLine.data.takeOffQuantity.length > 0
        ? selectedLine.data.takeOffQuantity[0]
        : "";

    return (
      <React.Fragment>
        {WBSStore.currentTab == EWBSView.EAP ? (
          <div>
            <Typography className={classes.title} component="div">
              {i18n.project.rightSideMenu.properties}
            </Typography>
            {selectedLine.index !== -1 && WBSStore.tab === 0 ? (
              selectedLine.data.rowType === ERowType.STAGE ? (
                <>
                  <div className={classes.content} key={selectedLine.id}>
                    <CustomProps
                      lineIndex={selectedLine.index}
                      type={"eap"}
                      reloading={CustomPropertyStore.reloading}
                    />
                    {selectedLine.data.fromModelMap && (
                      <DisplayButton
                        title={i18n.project.rightSideMenu.viewer3d}
                        buttonTestId={"button-TabPropertiesIsolateItems"}
                        buttonLabel={`${i18n.viewer.isolateFromTakeOff.isolate} ${i18n.viewer.isolateFromTakeOff.items}`}
                        Icon={CompareBlack}
                        onClick={(e) => this.handleIsolateClick(e)}
                      />
                    )}
                  </div>
                </>
              ) : selectedLine.data.rowType === ERowType.BLANK ? (
                <div className={classes.table}>
                  <div className={classes.tableCell}>
                    <img src={cone} />
                    <Typography className={classes.stageTitle} component="span">
                      {i18n.project.rightSideMenu.stage.title}
                    </Typography>
                    <Typography
                      className={classes.stageSubtitle}
                      component="span"
                    >
                      {i18n.project.rightSideMenu.stage.subtitle}
                    </Typography>
                  </div>
                </div>
              ) : (
                <div
                  className={classes.content}
                  key={selectedLine.id}
                  style={{ height: window.innerHeight - 90 }}
                >
                  <RowCode
                    handleCodeFocus={this.handleCodeFocus}
                    handleCodeBlur={this.handleCodeBlur}
                    classes={classes}
                  />
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="type">
                      {i18n.project.rightSideMenu.type}
                    </InputLabel>
                    <Select
                      value={this.typeOfLine(selectedLine)}
                      onChange={this.handleChange}
                      inputProps={{ name: "select", id: "type" }}
                    >
                      {categories.map((ctgry) => (
                        <MenuItem key={ctgry} value={ctgry}>
                          {i18n.project.rightSideMenu.categories[ctgry]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <CostOriginProperties
                    rateLibraryId={selectedLine.data.rateLibraryId}
                    nameOnRateLibrary={selectedLine.data.rateLibraryName}
                    isTask={selectedLine.data.rowType === ERowType.TASK}
                  />
                  <DisplayButton
                    title={i18n.project.rightSideMenu.occurencesInBudget}
                    buttonTestId={"button-TabPropertiesShowItemOccurrences"}
                    buttonLabel={i18n.project.rightSideMenu.viewOccurrences}
                    Icon={Copy}
                    onClick={() =>
                      WBSItemOccurrencesStore.fetchAndShowItemOccurences(
                        selectedLine.data.contentId
                      )
                    }
                  />
                  <CustomProps
                    lineIndex={selectedLine.index}
                    type={"eap"}
                    reloading={CustomPropertyStore.reloading}
                  />
                  {selectedLine.data.fromModelMap &&
                    (!selectedLine.data.takeOffQuantity ||
                      selectedLine.data.takeOffQuantity.length === 0) && (
                      <FormControl className={classes.displayForm}>
                        <InputLabel shrink={true}>
                          {i18n.project.rightSideMenu.takeOffDescription}
                        </InputLabel>
                        <Typography className={classes.origin} component="div">
                          {selectedLine.data.modelMapDescription}
                        </Typography>
                      </FormControl>
                    )}
                  {selectedLine.data.fromModelMap &&
                    selectedLine.data.takeOffQuantity &&
                    selectedLine.data.takeOffQuantity.length > 0 && (
                      <FormControl className={classes.displayForm}>
                        <InputLabel shrink={true}>
                          {i18n.project.rightSideMenu.takeOffPath}
                        </InputLabel>
                        <Typography className={classes.origin} component="div">
                          <Map
                            className={classes.icon}
                            style={{ float: "left", marginLeft: -5 }}
                          />
                          <div
                            title={this.renderModelMapName()}
                            style={{
                              float: "left",
                              padding: 5,
                              width: 195,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {this.renderModelMapName()}
                          </div>
                          <div style={{ clear: "both", padding: "5px 0px" }}>
                            {this.renderPath()}
                          </div>
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            style={{
                              color: "rgba(255, 255, 255, 0.6)",
                              margin: "5px -2px",
                            }}
                            aria-haspopup="true"
                            onClick={this.handleClickOpenRemoveDialog}
                          >
                            <RemoveCircle
                              className={classNames(
                                classes.leftIcon,
                                classes.iconSmall
                              )}
                            />
                            {i18n.project.rightSideMenu.takeOffRemoveSource}
                          </Button>
                        </Typography>
                      </FormControl>
                    )}
                  {selectedLine.data.fromModelMap &&
                    selectedLine.data.takeOffQuantity &&
                    selectedLine.data.takeOffQuantity.length > 0 && (
                      <>
                        <FormControl className={classes.displayForm}>
                          <InputLabel shrink={true}>
                            {i18n.project.rightSideMenu.takeOffDescription}
                          </InputLabel>
                          <Typography
                            className={classes.origin}
                            component="div"
                          >
                            {takeOffDesc}
                          </Typography>
                        </FormControl>
                      </>
                    )}
                  {selectedLine.data.fromModelMap && (
                    <DisplayButton
                      title={i18n.project.rightSideMenu.viewer3d}
                      buttonTestId={"button-TabPropertiesIsolateItems"}
                      buttonLabel={`${i18n.viewer.isolateFromTakeOff.isolate} ${i18n.viewer.isolateFromTakeOff.items}`}
                      Icon={CompareBlack}
                      onClick={(e) => this.handleIsolateClick(e)}
                    />
                  )}
                </div>
              )
            ) : selectedLineIndexResources !== -1 && WBSStore.tab === 1 ? (
              <div className={classes.content} key={selectedLineIndexResources}>
                <CustomProps
                  lineIndex={selectedLineIndexResources}
                  type={"resources"}
                  reloading={CustomPropertyStore.reloading}
                />
              </div>
            ) : (
              WBSStore.WBS !== undefined && <WBSProperties />
            )}
          </div>
        ) : (
          <div>
            <div className={classes.container}>
              {count !== 0 ? (
                <Paper elevation={2} square className={classes.paper}>
                  <div className={classes.topBar}>
                    <Typography className={classes.topBarText} component="span">
                      {i18n.project.rightSideMenu.properties}
                    </Typography>
                  </div>
                  <div
                    className={classes.topBar}
                    style={{
                      backgroundColor: "#262527",
                      height: "60px",
                      paddingTop: "12px",
                    }}
                  >
                    <div className={classes.topBarWrapper}>
                      {count > 1 ? (
                        <img
                          className={classes.imgIcon}
                          src={multipleElements}
                        />
                      ) : (
                        <img className={classes.imgIcon} src={cube} />
                      )}
                      <Tooltip title={name !== undefined ? name : ""}>
                        <Typography className={classes.text} component="div">
                          {name}
                        </Typography>
                      </Tooltip>
                    </div>
                  </div>
                </Paper>
              ) : (
                <div />
              )}
              <div className={classes.list}>
                {libraries.length >= 0 ? (
                  <div>
                    {count == 1 ? (
                      <PropertiesTable
                        elements={Render3dStore.propertyRendered}
                      />
                    ) : (
                      <div
                        className={
                          count !== 0
                            ? classes.tablePropsWrapper
                            : classes.tableTwo
                        }
                        style={{ margin: "0 auto" }}
                      >
                        {count !== 0 ? (
                          <PropertiesTable
                            elements={Render3dStore.propertyRendered}
                          />
                        ) : (
                          <div
                            className={classes.tableCell}
                            style={{ padding: 0 }}
                          >
                            <img src={cone} />
                            <Typography
                              className={classes.stageTitle}
                              component="span"
                            >
                              {i18n.viewer.properties.noProperties}
                            </Typography>
                            <Typography
                              className={classes.stageSubtitle}
                              component="span"
                            >
                              {i18n.viewer.properties.noInfos1}
                            </Typography>
                            <Typography
                              className={classes.stageSubtitle}
                              component="span"
                            >
                              {i18n.viewer.properties.noInfos2}
                            </Typography>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className={classes.table} style={{ margin: "0 auto" }}>
                    <div className={classes.tableCell} style={{ padding: 0 }}>
                      <img src={cone} />
                      <Typography
                        className={classes.stageTitle}
                        component="span"
                      ></Typography>
                      <Typography
                        className={classes.stageSubtitle}
                        component="span"
                      >
                        {i18n.viewer.navigator.empty.subtitle1}
                      </Typography>
                      <Typography
                        className={classes.stageSubtitle}
                        component="span"
                      >
                        {i18n.viewer.navigator.empty.subtitle2}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <Dialog
          open={this.state.open}
          onClose={this.handleClickClose}
          aria-labelledby="draggable-dialog-title"
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <DialogTitle id="draggable-dialog-title" style={{ padding: "20px" }}>
            <p style={{ color: "#f2f2f2", fontSize: "18px", margin: 0 }}>
              {i18n.modelMaps.removeLink.title}
            </p>
            <IconButton
              onClick={this.handleClickClose}
              className={classes.closeIcon}
              style={{ position: "absolute" }}
            >
              <Close fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <DialogContentText style={{ padding: 0 }}>
              <p style={{ color: "#a6a6a6", fontSize: "16px", margin: 0 }}>
                {i18n.modelMaps.removeLink.content1}
                <span style={{ color: "#FFFFFF" }}>
                  {this.renderModelMapName()}
                </span>
                {i18n.modelMaps.removeLink.content2}
              </p>
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              autoFocus
              className={classes.confirmButton}
              onClick={this.handleClick}
            >
              {i18n.yes}
            </Button>
            <Button onClick={this.handleClickClose} color="secondary">
              {i18n.no}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(Tab1);



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/layouts/Tab1.tsx